<script setup lang="ts">
type CucumberProps = {
  isOutline: boolean
  styles: {
    top: string
    left: string
    transform: string
    position: 'absolute' | 'fixed'
  }
  color?: string
}

const props = defineProps<CucumberProps>()

const getColor = (defaultColor: string) => {
  return props.color ? props.color : defaultColor
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1356.28 1095.07"
    :style="styles"
    class="-z-1 h-[25vh] w-[25vh] overflow-hidden"
  >
    <g id="a" />
    <g id="b">
      <path
        class="u"
        :fill="getColor('#08634b')"
        :fill-opacity="isOutline ? 0 : 1"
        :stroke-width="isOutline ? 10 : 0"
        stroke="#FFFFFF"
        d="M42.81,86.02c-5.84-8.07-7.38-44.9-.06-52.52,12.29-12.78,21.52,24.93,28.77,34.6,20.53-4.43,31.66-15.22,54.1-10.37,35.84,7.76,73.22,25.47,107.97,38.24,39.67,14.58,82.61,28.62,120.64,46.55,19.32,9.11,36.71,22.77,56.01,31.86,20.04,9.44,39.36,16.51,57.38,29.48,20.46,14.73,43.24,27.56,62.96,43,18.84,14.76,35.02,32.6,54.3,46.88,20.26,15.02,45.49,19.77,65.07,34.94,17.31,13.41,24.41,21.7,44.16,31.59,46.01,23.03,79.64,65.04,122.32,93.26,42.03,27.79,83.5,56.96,123.02,88.4,25.92,20.62,59.75,38.88,82.69,62.45,7.7,7.91,12.21,18.36,20.58,26.4,13.62,13.08,30.05,21.89,45.28,32.87,19.57,14.1,25.62,33.73,41.48,50.56,14.96,15.87,35.43,28.53,51.54,43.8,12.34,11.69,25.39,22.66,37.47,34.61,46.47,45.98,88.16,93.94,91.67,161.7,1.26,24.41,13.64,73.48-5.69,93.09-31.72,32.19-81.24,10.15-115.35-1.5-65.62-22.42-112.15-75.16-174.9-103.19-22.21-9.92-28.54-28.84-46.87-42.39-25.81-19.08-59.31-27.19-84.3-48.49-75.81-64.64-149.4-134.18-235.14-185.75-33.29-20.03-65.64-41.55-98.53-62.22-23.65-14.87-47.71-28.04-70.07-44.96-23.55-17.81-43.61-39.66-68.88-55.33-19.07-11.82-40.92-17.8-60.7-28.63-20.05-10.98-36.08-25.28-54.74-38.23-19.04-13.21-40.01-24.94-56.57-41.41-16.37-16.28-28.71-37.05-44.93-54.01-30.4-31.79-61.23-60.68-94.9-89.04-21.11-17.78-34.3-40.48-50.8-61.86-16.83-21.81-27.69-43.77-20.69-72.14,2.14-8.7,5.73-17.12,15.75-32.24Z"
      />
    </g>
    <g id="c" />
    <g id="d" />
    <g id="e" />
    <g id="f" />
    <g id="g" />
    <g id="h" />
    <g id="i" />
    <g id="j">
      <g id="k" />
      <g id="l" />
      <g id="m" />
      <g id="n" />
      <g id="o" />
      <g id="p" />
      <g id="q" />
      <g id="r" />
      <g id="s" />
      <g id="t" />
    </g>
  </svg>
</template>

<style scoped></style>
